module.exports = __webpack_public_path__ + "static/img/newimg1.e38e7f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newimg1.png
// module id = gNrV
// module chunks = 2